import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['en', 'pt', 'es'], // Adicione os idiomas suportados aqui
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        cleanCode: true,
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false, // React already safes from xss
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Caminho para os arquivos de tradução
        },
    });

export default i18n;
